import Pusher from 'pusher-js';
const pusher = (channel) =>
  new Pusher(process.env.NEXT_PUBLIC_PUSHER_APP_KEY, {
    cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
    forceTLS: true,
    enabledTransports: ['ws', 'xhr_streaming', 'xhr_polling'],
    // disabledTransports: ['xhr_polling', 'xhr_streaming'], // Optional: Disable fallback to polling
  }).subscribe(channel);

export const pusherUnsubscribe = (channel) => {
  new Pusher(process.env.NEXT_PUBLIC_PUSHER_APP_KEY, {
    cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
    forceTLS: true,
    enabledTransports: ['ws', 'xhr_streaming', 'xhr_polling'],
    // disabledTransports: ['xhr_polling', 'xhr_streaming'], // Optional: Disable fallback to polling
  }).unsubscribe(channel);
};

// export const checkAlreadySubscribedToTheChannel = (channelName) => {
//   const pusher = new Pusher(process.env.NEXT_PUBLIC_PUSHER_APP_KEY, {
//     cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
//   });

//   if (pusher.channel(channelName)) {
//     return true;
//   } else {
//     return false;
//   }
// };

export default pusher;
